import { gql } from "graphql-request";

export const CHECKOUT_SESSION_QUERY = gql`
  query checkoutSessionTokenQuery(
    $input: CheckoutSessionTokenInput!
  ) {
    checkoutSessionToken(input: $input)
  }
`;

export const CUSTOMER_PORTAL_SESSION_QUERY = gql`
  query CustomerPortalTokenQuery(
    $input: CustomerPortalTokenInput!
  ) {
    customerPortalToken(input: $input)
  }
`;

export const USER_SYNC_MUTATION = gql`
  mutation UserSync {
  userSync {
    user {
      email
      externalAuthId
      firstName
      fullName
      lastName
      hasActiveSubscription
      id
      isActive
      isDeleted
      isOnFreePlan
      paymentCustomerId

      currentSubscription {
        id
        provider
        subscriptionPlanPriceId
        subscriptionStatus
        subscriptionPlanPrice {
          id
          externalPriceId
        }
      }
      userSubscriptions {
        id
        isActive
        provider
        subscriptionPlanPriceId
        subscriptionStatus
        subscriptionPlanPrice {
          id
          createdAt
          createdBy
          externalPriceId
          isAvailable
          isDeleted
          priceCents
          subscriptionPlanId
          type
          updatedAt
          updatedBy
          subscriptionPlan {
            id
            externalPlanId
            name
            updatedAt
            updatedBy
          }
        }
      }
    }
  }
}
`;


export const SUBSCRIPTION_PRICES = gql`
  query SubscriptionPrices {
    subscriptions {
      createdAt
      createdBy
      description
      displayOrder
      externalPlanId
      id
      isAvailable
      isDeleted
      maxGigsPerProject
      maxProjects
      maxSetListsPerProject
      maxSongsPerProject
      maxStorageMB
      name
      supportsAnalytics
      supportsCollaboration
      supportsPrioritySupport
      updatedAt
      updatedBy
      subscriptionPlanPrices {
        createdAt
        createdBy
        currency
        externalPriceId
        id
        isAvailable
        isDeleted
        priceCents
        subscriptionPlanId
        type
        updatedAt
        updatedBy
      }
    }
  }
`;

export const ORDER_PREVIEW_QUERY = gql`
  query OrderPreview($input: OrderPreviewInput!) {
    orderPreview(input: $input) {
      pricingId
      planName
      planDescription
      maxProjects
      maxSongsPerProject
      maxSetListsPerProject
      maxGigsPerProject
      maxStorageMb
      supportsCollaboration
      supportsAnalytics
      supportsPrioritySupport
      currency
      interval
      listPriceCents
      trialAvailable
      trialPeriodDays
      trialPeriodMonths
      trialEndsAt
      firstPaymentAt
      firstPaymentGrossCents
      priceFullyDisclosed
      netCents
      taxCents
      grossCents
      taxType
    }
  }
`;
